<template>
  <div>
    <hr>
    <div @key="team.id" v-for="team in userTeams">
      <h4>{{ team.account.company }}</h4>
      <form>
        <div style="padding-bottom: 10px">
          <div class="settings-container">
            <div>
              <label> Team Member Name
                <input type="text" v-model="team.title">
              </label>
            </div>
            <div>
              <label> Visible
                <input type="checkbox" v-model="team.visible">
              </label>
            </div>
            <div>
              <label> Receive Notifications
                <input type="checkbox" v-model="team.notify">
              </label>
            </div>
          </div>

        </div>
        <div>
          <button @click.prevent="updateTeam(team)" class="bbutton">Update</button>
          <button @click.prevent="deleteTeam(team.id, team.account.company)" class="bbutton">Delete</button>
        </div>
        <hr>
      </form>
    </div>
  </div>
</template>

<script>

import axios from "axios";

export default {
  name: "AdminUserTeamManagement",
  data () {
    return {
      'userTeams': [],
    };
  },
  mounted () {
    this.userTeams = JSON.parse(this.teams);
  },
  computed: {

  },
  methods: {
    updateTeam (team) {
      axios({
        method: 'PATCH',
        url: `/admin/manage-team/${team.id}`,
        data: {
          payload: {
            'visible': team.visible,
            'notify': team.notify,
            'title': team.title,
          },
        }
      }).then(() => {
        alert('updated!');
      })
    },
    deleteTeam (id, team) {
      if (confirm(`Do you really want to delete user from ${team}?`)) {
        axios({
          method: 'DELETE',
          url: `/admin/manage-team/${id}`,
        }).then(() => {
          this.userTeams = this.userTeams.filter(t => t.id !== id);
          alert('updated!');
        })
      }
    }
  },
  props: [
    'teams',
  ],
};
</script>

<style scoped>
.settings-container {
  display: flex;
  width: 800px;
  justify-content: space-between;
  padding-bottom: 10px;
}
</style>
